import React from 'react';
import { useIntl } from 'react-intl';
import Switch from 'react-switch';
import { FaHeart, FaBars } from 'react-icons/fa';
import reactLogo from './images/logo.svg';
import { ShimmerFeaturedGallery } from "react-shimmer-effects";
import Table from './table/Datatable';


import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DetailForm from './DetailForm';
import Profile from './Profile';
import { ApprovalForm } from './ApprovalForm';
import Timeline from './Timeline';
import { OneDRideAccounts } from './OneDRideAccounts';
import { DriveConnects } from './DriveConnects';
import { Visualizer } from './vis';
import { Navigate, Router } from 'react-router-dom';
import { AIOnboarding } from './AIOnboarding';


const Main = ({
  collapsed,
  rtl,
  image,
  handleToggleSidebar,
  handleCollapsedChange,
  handleRtlChange,
  handleImageChange,
  state
}) => {
  const intl = useIntl();
  return (
    <main style={{marginTop:"70px"}} className='pt-0'>
        {
            state =="dashboard" && <Timeline/>
            // <ShimmerFeaturedGallery row={2} col={2} card frameHeight={800} />
        }
        {
            state =="components" && <ApprovalForm/>


            
        }
        {
            state =="onboarding" && <AIOnboarding/>


            
        }
        
        {
            state =="1DRideAccounts" && <OneDRideAccounts/>
        }
        {
            state =="profile" && <Profile/>


           
        }
         {
            state =="driverConnect" && <DriveConnects/>


           
        }
          {
            state =="liveDrivers" && <Navigate to="/vis" />


           
        }


        {
            state=="settings" && 
        <>
      <div className="btn-toggle" onClick={() => handleToggleSidebar(true)}>
        <FaBars />
      </div>
      <header>
        <h1>
          <img width={80} src={reactLogo} alt="react logo" /> {intl.formatMessage({ id: 'title' })}
        </h1>
        <p>{intl.formatMessage({ id: 'description' })}</p>
       
      </header>
      <div className="block ">
        <Switch
          height={16}
          width={30}
          checkedIcon={false}
          uncheckedIcon={false}
          onChange={handleCollapsedChange}
          checked={collapsed}
          onColor="#219de9"
          offColor="#bbbbbb"
        />
        <span> {intl.formatMessage({ id: 'collapsed' })}</span>
      </div>
      <div className="block">
        <Switch
          height={16}
          width={30}
          checkedIcon={false}
          uncheckedIcon={false}
          onChange={handleRtlChange}
          checked={rtl}
          onColor="#219de9"
          offColor="#bbbbbb"
        />
        <span> {intl.formatMessage({ id: 'rtl' })}</span>
      </div>
      <div className="block">
        <Switch
          height={16}
          width={30}
          checkedIcon={false}
          uncheckedIcon={false}
          onChange={handleImageChange}
          checked={image}
          onColor="#219de9"
          offColor="#bbbbbb"
        />
        <span> {intl.formatMessage({ id: 'image' })}</span>
      </div>

      <footer>
        
        <br />
        <div className="social-bagdes">
          
        </div>
      </footer>
      </>
}
    </main>
  );
};

export default Main;